import t from "./index944.js";
import a from "./index820.js";
var e = t(a, "DataView");
export {
  e as default
};
